import { generateUrl } from '@zenbusiness/common-components/SharedAsset';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import superstyled from '#client/pages/EducationStudio/utils/superstyled';

const Container = superstyled({
  tag: Box,
  propsNeeded: ['image'],
  styles: ({ image }) => ({
    backgroundImage: `url(${generateUrl(`${image}`, null, null, 'auto')})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    height: '18.75rem',
    margin: '0 -1rem 1rem -1rem'
  })
});

const Shadow = superstyled({
  tag: Box,
  styles: {
    backgroundImage: 'linear-gradient(0deg, #000 0%, transparent 70%)',
    height: '100%'
  }
});

const Content = superstyled({
  tag: Box,
  styles: {
    display: 'flex',
    alignContent: 'flex-end',
    flexWrap: 'wrap',
    height: '100%',
    padding: '0 1.5rem 3.25rem 1.5rem'
  }
});
export const BackgroundImageWithText = ({ image, children }) => (
  <Container image={image}>
    <Shadow>
      <Content>
        {children}
      </Content>
    </Shadow>
  </Container>
);

BackgroundImageWithText.propTypes = {
  image: PropTypes.string
};

BackgroundImageWithText.defaultProps = {
  image: ''
};
